'use client'

import React from 'react'

type Props = {
    side: number
}

const WIDTH = 340
const HEIGHT = 220

export default function SquareChart({ side }: Props) {
    const s = 140
    const x = (WIDTH - s) / 2
    const y = (HEIGHT - s) / 2

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <rect x={x} y={y} width={s} height={s} fill="#2563eb" opacity={0.18} stroke="#2563eb" strokeWidth={2} />
            <text x={x + s / 2} y={y + s + 20} fontSize={12} textAnchor="middle" fill="#374151">a = {side.toFixed(2)}</text>
        </svg>
    )
}
